import { Link, useLocation } from "@tanstack/react-router";
import type { ReactElement } from "react";
import { HeartDarkIcon } from "@/components/icons/heartFull";
import { HeartIcon } from "@/components/icons/heart";
import { HomeIcon } from "@/components/icons/home";
// import { Library, LibraryBig } from "lucide-react";


export const MenuBottomBarOffline = (): ReactElement => {
	const { pathname } = useLocation();

	return (
		<nav className="flex justify-around w-full">
			<Link className="xxs:p-5" to="/offline-mode">
				<HomeIcon fill={pathname === "/offline-mode" ? "#212B36" : "white"} />
			</Link>
			<Link className="xxs:p-5" to="/offline-videos">
				{pathname === "/offline-videos" ? <HeartDarkIcon /> : <HeartIcon />}
			</Link>
			{/* <Link className="xxs:p-5" to="/articles">
				{pathname === "/articles" ? <Library /> : <LibraryBig />}
			</Link> */}
		</nav>
	);
};
